import { FC } from "react";

interface IsAllowedProps {
}
 
const IsAllowed: FC<IsAllowedProps> = () => {
    // const router = useRouter();
    // const pathname = usePathname();
    // const [loading, setLoading] = useState(true)

    // useEffect(() => {
    //   setLoading(true);
    //     if (
    //       (pathname.includes("/dashboard") ||
    //         pathname.includes("/architecture") ||
    //         pathname.includes("/marketplace")) &&
    //       !localStorage.getItem("accessToken")
    //     ) {
    //       router.push("/");
    //       setLoading(false);
    //     } else {
    //       setLoading(false);
    //     }
    // }, [pathname, router]);

    return (
      <>
      </>
    );
}
 
export default IsAllowed;